import { render, staticRenderFns } from "./IconPopup.vue?vue&type=template&id=b10688be&"
import script from "./IconPopup.vue?vue&type=script&lang=js&"
export * from "./IconPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports